import { lazy, Suspense, FunctionComponent } from 'react';
import { PlacementOptions } from 'dibs-contact-1stdibs/exports/Contact1stdibsModalPlacements';

const Contact1stdibsModalLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "Contact1stdibsModal" */ 'dibs-contact-1stdibs/exports/Contact1stdibsModal'
        )
);

type Contact1stdibsModalProps = {
    isOpen: boolean;
    onClose: () => void;
    placement: PlacementOptions;
};

const Contact1stdibsModal: FunctionComponent<Contact1stdibsModalProps> = ({
    isOpen,
    onClose,
    placement,
}) =>
    isOpen ? (
        <Suspense fallback={null}>
            <Contact1stdibsModalLazy placement={placement} onClose={onClose} isOpen />
        </Suspense>
    ) : null;

export default Contact1stdibsModal;
